import { all, takeLatest, put, select } from 'redux-saga/effects';
import { USER_FOUND, Action } from 'redux-oidc';
import { User } from 'oidc-client';
import Api from '../services/ApiManager';
import { appInitAction, updateBearer } from '../actions/appActions';
import { RootState } from '../../model/rootReducer';

function* handleUserFound(action: Action<User>) {
  if (action.payload?.access_token) {
    const isAppInitialized = yield select((state:RootState)=> state.app.isInitialized);
    yield put (updateBearer(action.payload?.access_token));
    Api.setBearer(action.payload?.access_token);
    if(!isAppInitialized){
      yield put(appInitAction.request({}));
    }
  }
}

export default function* oidcSagas() {
  yield all([takeLatest(USER_FOUND, handleUserFound)]);
}
